import React, { useState } from 'react';

import { languageCodeToName } from 'js/lib/language';

import { useLanguageInfoDialog } from 'bundles/unified-description-page-common/contexts/LanguageInfoDialogContext';
import { usePageInfo } from 'bundles/unified-description-page-common/contexts/PageInfoContext';
import TranslationsNotificationBannerContext from 'bundles/unified-description-page-common/contexts/consumer/TranslationsNotificationBannerContext';
import shouldShowTranslationsNotificationBanner from 'bundles/unified-description-page-common/utils/shouldShowTranslationsNotificationBanner';

type Props = {
  productType: string;
  translatedLanguages: Array<{ code: string }>;
  originalLanguage: string;
  children: React.ReactNode;
};

const TranslationsNotificationBannerProvider = ({
  children,
  productType,
  translatedLanguages,
  originalLanguage,
}: Props) => {
  const [hideBanner, setHideBanner] = useState(false);
  const { subfolderLocaleCode } = usePageInfo();
  const { openDialog } = useLanguageInfoDialog();
  const translatedLanguagesCode = translatedLanguages.map((language) => language.code);

  const subfolderLanguage = languageCodeToName(subfolderLocaleCode || '');

  const showBanner =
    !hideBanner &&
    shouldShowTranslationsNotificationBanner({ subfolderLocaleCode, originalLanguage, translatedLanguagesCode });

  const value = {
    showBanner,
    setHideBanner,
    openDialog,
    productType,
    subfolderLanguage,
    hasTranslations: translatedLanguages.length > 0,
  };

  return (
    <TranslationsNotificationBannerContext.Provider value={value}>
      {children}
    </TranslationsNotificationBannerContext.Provider>
  );
};

export default TranslationsNotificationBannerProvider;
